<ion-list lines="none">
  <ion-row class="title-container">
    <ion-label>{{page.title | translate}}</ion-label>
  </ion-row>
  
  <div class="submenu-container">
    <div *ngFor="let sub of page.children; let j = index">
      <ion-item (click)="navigateTo(sub)" [ngClass]="{'selected': selectedSubMenu == sub}" lines="none" detail="false">
        <ion-icon *ngIf="selectedSubMenu != sub && selectedTheme == 'light'" slot="start" [src]="'assets/icon/menu/' + sub.icon_inactive"></ion-icon>
        <ion-icon *ngIf="selectedSubMenu != sub && selectedTheme == 'dark'" slot="start" [src]="'assets/icon/menu/' + sub.icon_inactive_dark"></ion-icon>
        <ion-icon *ngIf="selectedSubMenu == sub" slot="start" class="wb-filter-mycustom" [src]="'assets/icon/menu/' + sub.icon_active"></ion-icon>
        <ion-label >{{ sub.title | translate}}</ion-label> 
      </ion-item>
    </div>
  </div>
</ion-list>
  
  